import { useState, useEffect, useContext } from 'react'
import {Routes, Route, BrowserRouter, Navigate, useParams  } from 'react-router-dom'
import axios from 'axios'
import { useDispatch } from "react-redux";

import AppContext from './AuthContext';
import EntryFrems from '../EntryFrems';
//import App from '../../App';
import PrivateRoutes from './PrivateRoutes';
import Login from '../pages/login/Login';
import ErrorPage from '../pages/error/ErrorPage';
import DeveloperRoutes from './DeveloperRoutes';
import AgentRoute from './AgentRoute';

import LangingRoute from './LangingRoute';

import SystemAdminRoutes from './SystemAdminRoutes';
import SystemLogin from '../pages/login/SystemLogin';

import { storePermission } from '../redux/managePermissionSlice';


const AppRoutes = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(true);
    const [businessDetails, setBusinessDetails] = useState(null);
    const [isValidSubdomain, setIsValidSubdomain] = useState(true);

    const subdomain = getSubdomain();
    // const subdomain = 'lipozene';
  
    useEffect(() => {
        const getBusinessDetails = async() => {
            try {
                let sub_domain = '';
                if(loginUserType === 'SA'){
                    sub_domain = company
                } else {
                    sub_domain= subdomain
                }

                setVisible(true);
                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    }
                };
                const api_params = {
                    sub_domain: sub_domain
                }
                await axios.post(`${process.env.REACT_APP_API_URL}api/valid-subdomains`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        if(res.data.data.length > 0){
                            setBusinessDetails(res.data.data[0]);
                            setIsValidSubdomain(true);
                            setVisible(false)
                            localStorage.setItem('sass_id', res.data.data[0].sass_id);
                            localStorage.setItem('subdomain', res.data.data[0].biz_app_url);
                            localStorage.setItem('business_name', res.data.data[0].business_name);
                            localStorage.setItem('business_email', res.data.data[0].biz_email);
                        } else {
                            setBusinessDetails(null);
                            setIsValidSubdomain(false);
                            setVisible(false)
                        }
                    } else if(res.data.status === 'error') {
                        setIsValidSubdomain(false);
                        setVisible(false)
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            } catch (error2) {
                console.error(error2)
            }  
        }
        getBusinessDetails();
    }, [subdomain]);

    const authCtx = useContext(AppContext);

    const getpermission = async () => {

        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        var api_headers = {
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        const api_params = {
            login_user_type: loginUserType
        }
        await axios.post(`${api_base_url}admin/get-permission`, api_params, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                const permissionObj = {};
                if(res.data.data.data.length > 0){
                    const permissionData = res.data.data.data[0].manage_permission;
                    permissionObj.allow_change_permission = permissionData.allow_change_permission;
                    permissionObj.allow_data_edit = permissionData.allow_data_edit;
                    permissionObj.allow_data_delete = permissionData.allow_data_delete;
                    permissionObj.allow_add_new = permissionData.allow_data_add;
                }
                else{
                    permissionObj.allow_change_permission = 'Y';
                    permissionObj.allow_data_edit = 'Y';
                    permissionObj.allow_data_delete = 'Y';
                    permissionObj.allow_add_new = 'Y';
                }
                dispatch(storePermission(permissionObj))
            } else if(res.data.status === 'error') {
                console.error('error')
            }
        })
        .catch((error) => {
            console.error(error);
        })
    }
    useEffect(() => {
        if(authCtx.isLoginType === 'A' || authCtx.isLoginType === 'D'){
            if(authCtx.isLoggedIn){
                getpermission();
            }
        }
    },[authCtx.isLoggedIn]);
    
    return (
        
        <BrowserRouter>
            <Routes>
                <Route element={<EntryFrems visible={visible} />} >
                    <Route path='/error' element={<ErrorPage />} />
                    {/* <Route path='/login' element={<Login />} /> */}
                    {subdomain && isValidSubdomain ? (
                        <>
                            <Route
                                path='/*'
                                element={
                                    authCtx.isLoggedIn ?(
                                        authCtx.isLoginType === 'A' ?
                                            <>
                                                <PrivateRoutes />
                                            </>
                                        :
                                        authCtx.isLoginType === 'D' ?
                                            <>
                                                <DeveloperRoutes/>
                                            </>
                                        :
                                        authCtx.isLoginType === 'E' ?
                                            <>
                                                <AgentRoute/>
                                            </>
                                        :
                                        <Navigate to='/login' />
                                    )
                                    :
                                    <Navigate to='/login' />
                                } 
                            />
                            <Route
                                path="/login"
                                // element={
                                //     authCtx.isLoggedIn ? (
                                //         subdomain ? (
                                //             authCtx.isLoginType === 'A' ? 
                                //                 <Navigate to="/agents" replace  />
                                //             : authCtx.isLoginType === 'E' ?
                                //                 <Navigate to="/agent" />
                                //             : authCtx.isLoginType === 'D' ?
                                //                 <Navigate to="/agents" />
                                //             : <Login data={businessDetails} />
                                //         ) : (
                                //             <Login data={businessDetails} />
                                //         )
                                //     ) : (
                                //         <Login data={businessDetails} />
                                //     )
                                // }

                                element={
                                    authCtx.isLoggedIn ? (
                                        authCtx.isLoginType === 'A' ? 
                                        (
                                            <Navigate to="/agents" />
                                        ) 
                                        : authCtx.isLoginType === 'E' ? 
                                        (
                                            <Navigate to="/agent" />
                                        ) 
                                        : authCtx.isLoginType === 'D' ? 
                                        (
                                            <Navigate to="/agents" />
                                        )
                                        : 
                                        (
                                            <Login data={businessDetails} />
                                        )
                                    ) : (
                                        <Login data={businessDetails} />
                                    )
                                }
                            />
                            <Route
                                path='/'
                                // element={
                                //     authCtx.isLoggedIn ? (
                                //         subdomain ? (
                                //             <Navigate to={
                                //                 authCtx.isLoginType === 'A' 
                                //                     ? '/agents'
                                //                 : authCtx.isLoginType === 'E' 
                                //                     ? '/agent'
                                //                 : authCtx.isLoginType === 'D' 
                                //                     ? '/agents'
                                //                 : '/login'
                                //             } />
                                //         ) : (
                                //             <Navigate to="/login" />
                                //         )
                                //     ) : (
                                //         <Navigate to="/login" />
                                //     )
                                // }

                                element={
                                    authCtx.isLoggedIn ? (
                                        <Navigate to={
                                            authCtx.isLoginType === 'A' 
                                            ? '/agents'
                                            : authCtx.isLoginType === 'E' 
                                            ? '/agent'
                                            : authCtx.isLoginType === 'D' 
                                            ? '/agents'
                                            : '/login'
                                        }/>
                                    )
                                    : 
                                    <Navigate to='/login' />
                                }
                            />
                        </>
                    ) : (
                        <>
                            <Route
                                path='/system-admin/*'
                                element={
                                    authCtx.isLoggedIn ?(
                                        authCtx.isLoginType === 'SA' ?
                                            <>
                                                <SystemAdminRoutes />
                                            </>
                                        :
                                        <Navigate to="/system-admin" />
                                    )
                                    :
                                    <Navigate to="/system-admin" />
                                } 
                            />
                            <Route
                                path="/system-admin/"
                                element={
                                    authCtx.isLoggedIn ? (
                                        authCtx.isLoginType === 'SA' ? 
                                        (
                                            <Navigate to="/system-admin/dashboard" />
                                        ) 
                                        : 
                                        (
                                            <SystemLogin />
                                        )
                                    ) : (
                                        <SystemLogin />
                                    )
                                }
                            />
                            <Route
                                path='/system-admin'
                                element={
                                    authCtx.isLoggedIn ? (
                                        authCtx.isLoginType === 'SA' ?
                                        (
                                            <Navigate to="/system-admin/dashboard" />
                                        ) 
                                        : 
                                        (
                                            <Navigate to="/system-admin/" />
                                        )
                                    )
                                    : 
                                    <Navigate to="/system-admin/" />
                                }
                            />
                        </>
                    )}
                    {!subdomain && isValidSubdomain && (
                        <>
                            <Route
                                path='/system-admin/*'
                                element={
                                    authCtx.isLoggedIn ?(
                                        authCtx.isLoginType === 'SA' ?
                                            <>
                                                <SystemAdminRoutes />
                                            </>
                                        :
                                        <Navigate to="/system-admin" />
                                    )
                                    :
                                    <Navigate to="/system-admin" />
                                } 
                            />
                            <Route
                                path="/system-admin/"
                                element={
                                    authCtx.isLoggedIn ? (
                                        authCtx.isLoginType === 'SA' ? 
                                        (
                                            <Navigate to="/system-admin/dashboard" />
                                        ) 
                                        : 
                                        (
                                            <SystemLogin />
                                        )
                                    ) : (
                                        <SystemLogin />
                                    )
                                }
                            />
                            <Route
                                path='/system-admin'
                                element={
                                    authCtx.isLoggedIn ? (
                                        authCtx.isLoginType === 'SA' ? 
                                        (
                                            <Navigate to="/system-admin/dashboard" />
                                        ) 
                                        : 
                                        (
                                            <Navigate to="/system-admin/" />
                                        )
                                    )
                                    : 
                                    <Navigate to="/system-admin/" />
                                }
                            />
                        </> 
                    )}
                    <Route path='/*' element={<LangingRoute />} />
                    {/* <Route path='/login' element={<Login />} /> */}
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 2) {
        return parts[0]; // "subdomain"
    }
    return null; // No subdomain
};

export default AppRoutes;